











import { Component, Vue } from "vue-property-decorator";
import { getAll } from "../api";
import { CredentialContainer } from "../models";
import CredentialTable from "../components/CredentialTable.vue";

@Component({
  components: {
    CredentialTable
  }
})
export default class Credentials extends Vue {
  credentials: CredentialContainer = {
    email_account: [],
    microsoft_office: [],
    exchange_online: [],
    microsoft_windows: [],
    users_external: [],
    users_rdp: [],
    users: []
  };

  mounted() {
    getAll().then(res => {
      this.credentials = res;
    });
  }
}
